import React from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";

import SectionTitle from "../home/SectionTitle";

const ITEMS = [
  { num: "01", titleKey: "accountsPage.opens.item1.title", textKey: "accountsPage.opens.item1.text" },
  { num: "02", titleKey: "accountsPage.opens.item2.title", textKey: "accountsPage.opens.item2.text" },
  { num: "03", titleKey: "accountsPage.opens.item3.title", textKey: "accountsPage.opens.item3.text" },
  { num: "04", titleKey: "accountsPage.opens.item4.title", textKey: "accountsPage.opens.item4.text" },
];

function WhatOpens() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer">
        <SectionTitle
          title1={t("accountsPage.opens.title1")}
          title2={t("accountsPage.opens.title2")}
          text={t("accountsPage.opens.subtitle")}
          className="mx-auto max-w-[548px]"
        />

        <div className="mt-[25px] lg:mt-[50px] grid grid-cols-1 lg:grid-cols-2 gap-[16px] lg:gap-[35px]">
          <Fade cascade triggerOnce direction="up" damping={0.08}>
            {ITEMS.map((item) => (
              <div
                key={item.num}
                className="relative overflow-hidden rounded-[20px] lg:rounded-[28px] bg-gradient-to-r from-[#242f40] to-[#30425b] min-h-[104px] lg:min-h-[168px] flex items-center"
              >
                <span
                  className="absolute left-[16px] top-1/2 -translate-y-1/2 font-['Inter'] font-bold text-[42px] lg:text-[150px] leading-none text-[rgba(255,255,255,0.3)] select-none pointer-events-none"
                  aria-hidden
                >
                  {item.num}
                </span>
                <div className="relative ml-[77px] lg:ml-[268px] mr-[20px] py-[24px] flex flex-col gap-[8px] lg:gap-[12px]">
                  <p className="font-['Inter'] font-bold text-[16px] lg:text-[20px] leading-[1.2] text-white">
                    {t(item.titleKey)}
                  </p>
                  <p className="font-16-14-dark">{t(item.textKey)}</p>
                </div>
              </div>
            ))}
          </Fade>
        </div>
      </div>
    </section>
  );
}

export default WhatOpens;
